import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ThemeService } from '@progescode/theme';
import { APP_THEMES } from './app-theme.catalog';
import { AppThemeDefinition } from './app-theme.model';

@Injectable({ providedIn: 'root' })
export class AppThemeFacade {
  private readonly themeService = inject(ThemeService);
  private readonly currentThemeState = toSignal(this.themeService.currentTheme$, {
    initialValue: this.themeService.getCurrentTheme(),
  });

  readonly themes = APP_THEMES;
  readonly currentTheme = computed<AppThemeDefinition | null>(() => {
    const theme = this.currentThemeState();
    if (!theme) {
      return null;
    }

    return (
      APP_THEMES.find((item) => item.id === theme.id) ??
      (theme as AppThemeDefinition)
    );
  });

  setTheme(themeId: string): void {
    this.themeService.setTheme(themeId);
  }

  isActive(themeId: string): boolean {
    return this.currentTheme()?.id === themeId;
  }
}